export default __webpack_public_path__ + "static/media/alogo.b3e97aae.png";